import React, { Component } from 'react';
import '../../scss/PartyInput.scss';

export default class PartyInput extends Component {
  onChange(e) {
    this.props.onChange(e.target.value);
  }
  
  render() {
    return (
      <div className={`PartyInput PartyInput--${this.props.party}`}>
        <input
         id={this.props.party}
         type="radio"
         name="PartyInput"
         checked={this.props.checked}
         value={this.props.party}
         onChange={this.onChange.bind(this)}/>
        <label htmlFor={this.props.party} className="PartyInput__label">
          {this.props.party}
        </label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/src/js/lib/PartyInput.js